import { IScoreboardScore } from "@webng-types/write-model";

/**
 * The start date replaces the score display only before the match has
 * started and while no results are available.
 */
export function shouldShowStartDate(startsAt: Date | undefined, hasResults: boolean, now: Date): boolean {
  return !!startsAt && now < startsAt && !hasResults;
}

export function scoresHaveResults(scores?: IScoreboardScore[]): boolean {
  return !!scores && scores.some(score => scoreHasResults(score));
}

export function scoreHasResults(score?: IScoreboardScore): boolean {
  return !!(score?.home_score || score?.away_score);
}
